import { render, staticRenderFns } from "./ColorioNengaVersionUp.vue?vue&type=template&id=42cbb8f9&scoped=true&"
import script from "./ColorioNengaVersionUp.vue?vue&type=script&lang=js&"
export * from "./ColorioNengaVersionUp.vue?vue&type=script&lang=js&"
import style0 from "./ColorioNengaVersionUp.vue?vue&type=style&index=0&id=42cbb8f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cbb8f9",
  null
  
)

export default component.exports